import { render, staticRenderFns } from "./CommonSocialMediaCards.vue?vue&type=template&id=530a3c64&scoped=true&"
import script from "./CommonSocialMediaCards.vue?vue&type=script&lang=ts&"
export * from "./CommonSocialMediaCards.vue?vue&type=script&lang=ts&"
import style0 from "./CommonSocialMediaCards.vue?vue&type=style&index=0&id=530a3c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a3c64",
  null
  
)

export default component.exports